module.exports = __webpack_public_path__ + "static/assets/5bf3ab9f0225769a36ad4b100f36c36f.png";